import React, { createContext, useContext, useState } from "react";

const UserContext = createContext(undefined);
export const UserProvider = ({
  children,
}) => {
    const [profile, setProfile] = useState(null);
    return (
        <UserContext.Provider
        value={{
            profile,
            setProfile
        }}
        >
            {children}
        </UserContext.Provider>
    );
};
export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
};